import React from 'react';
import { Card, CardContent, Typography, Grid, Box, Divider } from '@mui/material';

const InfoCard = ({ title, details }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {details.map((detail, index) => (
            detail.value && (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    {detail.label}
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                    {detail.value}
                  </Typography>
                </Box>
              </Grid>
            )
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default InfoCard;
